<!--
 * @Description: 学生 详情 个别教育记录
 * @Author: PF
 * @Date: 2023-12-01 11:17:24
 * @LastEditors: PF
 * @LastEditTime: 2025-07-18 14:19:29
-->
<template>
  <div class="hp100">
    <el-table :data="tableData" border height="100%">
      <el-table-column label="学期" prop="xqmc" align="center" />
      <el-table-column label="日期" prop="rq" width="100" align="center" />
      <el-table-column label="教育情况" prop="jyqk" min-width="150" align="center" />
      <el-table-column label="效果" prop="xg" min-width="150" align="center" />
    </el-table>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { loadSelect } from '@/api/common.js'

const props = defineProps({
  row: { type: Object, required: false }
})
const tableData = ref([])

watch(
  () => props.row,
  () => {
    if (props.row) {
      loadSelect({ url: '/api/v2/xuesheng/banzhurengongzuogebiejiaoyujilu/list', data: tableData, parms: { xsid: props.row.id, order: 'rq', sort: 'desc' } })
    }
  },
  { deep: true, immediate: true }
)
</script>
